import ListMissionChoice from '../organisms/ListMissionChoice';
import { WithErrorBoundary } from '@bloomays-lib/ui.shared';
import { useUserStore } from '../../stores';

const MissionChoice = () => {
  const dataMe = useUserStore((state) => state.user);
  const isLoading = useUserStore((state) => state.userLoading);
  return (<ListMissionChoice data={dataMe?.bloomer?.mission} loading={isLoading} />) as React.ReactNode;
};

export default WithErrorBoundary(MissionChoice);
